import React from 'react';
import { Link } from '@zola/zola-ui';
import OtherThingsToReview from './OtherThingsToReview';

function TipProgram() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>4 Tips For Your Ceremony Programs</h3>
          <div className="section">
            <p className="desc" />
          </div>
          <div className="section">
            <p className="head">Tip 1: Coordinate them with your invitations.</p>
            <p className="desc">
              For a truly custom feel, choose a coordinating design for your entire wedding paper
              suite. You can shop for matching{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/save-the-date/shop"
                target="_blank"
              >
                save the dates
              </Link>
              ,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/invitations/shop"
                target="_blank"
              >
                invitations
              </Link>
              ,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/enclosures/shop"
                target="_blank"
              >
                enclosure cards
              </Link>
              ,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/programs/shop"
                target="_blank"
              >
                programs
              </Link>
              ,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/menus/shop"
                target="_blank"
              >
                menu cards
              </Link>
              , and{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/thank-you-cards/shop"
                target="_blank"
              >
                thank you cards
              </Link>{' '}
              on Zola, all of which also come with a coordinating (and free){' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/wedding-planning/website"
                target="_blank"
              >
                wedding website
              </Link>
              . Since they come in tons of different, equally stunning designs, you can find one
              that easily fits your wedding theme or style.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 2: Reinforce your wedding theme.</p>
            <p className="desc">
              Along the lines of theme, wedding ceremony programs are a great way to establish the
              style and mood of your big day. Whether you kick off your outdoor garden party with
              floral accents or set the tone for your preppy, nautical wedding with navy and white
              stripes, matching your program to your wedding’s decorative theme will put your guess
              in the right frame of mind.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 3: Keep it simple and brief.</p>
            <p className="desc">
              While{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/day-of-paper/a-guide-to-wedding-ceremony-programs"
                target="_blank"
              >
                we have given you lots of ideas
              </Link>{' '}
              for what to write in your programs, you don’t have to—and probably shouldn’t—include
              all of it. Remember that the ceremony program is meant to be a guide to your marriage
              service, so give guests just enough information to make them feel included without
              overwhelming or distracting them with too much text.
            </p>
          </div>
          <div className="section">
            <p className="head">Tip 4: Consider how many you really need.</p>
            <p className="desc">
              Depending on your budget, you might not choose to print one program for every
              attending guest. This is one area where you can cut costs by only printing one program
              for every couple, or two per family if there will be many families with children in
              attendance.
            </p>
          </div>
          <div className="section">
            <p className="desc">
              For more ideas on why you need programs, what to include on them, and how to word them
              for all types of ceremonies, read our{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/day-of-paper/a-guide-to-wedding-ceremony-programs"
                target="_blank"
              >
                Guide To Wedding Ceremony Programs.
              </Link>
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipProgram;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipProgram.jsx